import { Box, Checkbox, FormControlLabel, Stack, Typography } from '@mui/material'

import { SCOPE_GROUPS, toggleScope } from './apiKeyScopes'

export interface ApiKeyScopeSelectorProps {
  selected: string[]
  onChange: (scopes: string[]) => void
  disabled?: boolean
}

/**
 * The scope tree for an API key, in the style of a GitHub personal access token: a group checkbox
 * that selects everything under it, plus the individual actions. (WF-2657)
 */
export default function ApiKeyScopeSelector({ selected, onChange, disabled }: ApiKeyScopeSelectorProps) {
  const isChecked = (scope: string) => selected.includes(scope)

  return (
    <Stack spacing={1.5} id="api-key-scopes">
      {SCOPE_GROUPS.map(group => (
        <Box key={group.key}>
          <FormControlLabel
            control={
              <Checkbox
                id={`api-key-scope-${group.key}-all-checkbox`}
                size="small"
                checked={isChecked(group.allScope)}
                disabled={disabled}
                onChange={event => onChange(toggleScope(selected, group.allScope, event.target.checked))}
              />
            }
            label={
              <Typography variant="body2" fontWeight={600}>
                {group.label}
                <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                  {group.allScope}
                </Typography>
              </Typography>
            }
          />
          <Stack sx={{ pl: 4 }}>
            {group.children.map(child => (
              <FormControlLabel
                key={child.scope}
                control={
                  <Checkbox
                    id={`api-key-scope-${child.scope.replace(':', '-')}-checkbox`}
                    size="small"
                    checked={isChecked(child.scope)}
                    disabled={disabled}
                    onChange={event => onChange(toggleScope(selected, child.scope, event.target.checked))}
                  />
                }
                label={
                  <Typography variant="body2">
                    {child.label}
                    <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                      {child.scope}
                    </Typography>
                  </Typography>
                }
              />
            ))}
          </Stack>
        </Box>
      ))}
    </Stack>
  )
}
